/* eslint-disable max-len */
export default {
  en: {
    merge_request_cmd: 'You can also use the command line or your IDE to close this request.',
    merge_request_cmd_train: 'Add to Merge Train',
    merge_request_train_description:
      'A merge train is a queued list of merge requests, each waiting to be merged into the target branch.',
    merge_request_confirm_cancel: 'Are you sure you want to cancel the merge?',
    merge_request_confirm_close: 'Are you sure you want to close the merge?',
    merge_request_confirm_merge: 'Are you sure you want to merge?',
    merge_request: 'Merge Request | Merge Requests | No merge requests',
    create_merge_request: 'Create merge request',
    source: 'Source: ',
    target: 'Target: ',
    remove_source_branch: 'Delete the original branch after the merge request is accepted.',
    squash_commit: 'Perform a squash commit merge.',
    wants_to_merge_branch: 'want to merge a branch',
    branch_source: 'The source branch',
    lags_behind: 'is behind by',
    discussion: 'Discussion | Discussions',
    discussion_no: 'There are no discussions',
    discussion_closed: 'The discussion is closed',
    create_discussion_new: 'Start a new discussion',
    discussion_created: 'started a new discussion {date}',
    discussion_choose: 'discussion',
    answered_last: 'The last one answered',
    commit: 'commit | commits | commits',
    merge_request_assigned_to_me: 'Assigned to me',
    pipeline: 'Pipeline | Pipelines',
    manual_merge_disabled: 'Manual merging is disabled, automatic merging must be disabled',
    describe_reason: 'Describe the reason for blocking',
    mergeRequestNameTitle: 'Title',
    statusOpened: 'Opened',
    statusClosed: 'Closed',
    statusMerged: 'Merged',
    statusTrained: 'Added to Merge Train',
    statusTrainConflict: 'Conflict when passing a train',
    DISMISSED: 'Canceled',
    isBlocked: {
      allRequests: 'All requests',
      blockedRequests: 'Blocked',
      unblockedRequests: 'Unblocked'
    },
    viewType: 'View Type',
    inlineType: 'Inline',
    splitType: 'Split',
    CONFIRMED: 'Confirm',
    cancelMergeCommit: 'Cancel',
    labelMergeCommitField: 'Merge commit message',
    labelSquashCommitField: 'Squash commit message',
    enableSquashCommit: 'Change message for squash commit',
    infoSquashCommit:
      'If the message for a squash commit is empty, the default message will be used',
    titleMergeCommitField: 'Creating a commit',
    conflictsResolvedInBranch: 'Resolved conflicts in branch',
    commitInBranch: 'Commit will be made to the branch',
    markAsResolved: 'Mark as resolved',
    resolveConflicts: 'Resolve Conflicts',
    resolveConflictsDescription: 'Resolving merge conflicts between branches',
    branchesWithNoDiff:
      'Branches <code>{sourceBranch}</code> and <code>{targetBranch}</code> have no differences.',
    mergeRequestDisabled: {
      differentMergeBaseFork:
        'The source branch and the target branch have completely different commit histories.',
      differentMergeBase:
        'You will not be able to create a pull request because the source branch and the target branch have completely different commit histories.'
    },
    nothingToCompare: 'Nothing to compare',
    revertCommitHeaderMessage: 'Revert commit "{commitMessage}"',
    revertCommitDescriptionMessage: 'This commit will revert {commitToRevert} ("{commitMessage}")',
    identicalBranches: 'The branches are identical',
    identicalBranchesDescription:
      'You cannot create a merge request because two identical branches are selected',
    sourceBranchNeedToRebase: 'Rebase',
    sourceBranchNeedToRebaseLocalDescription:
      'The source branch must be rebased and conflicts resolved',
    sourceBranchNeedToRebaseDescription: 'The source branch must be rebased before merge',
    runPipelineMergeRequests:
      'merge result pipeline is not possible in a merge request with conflicts',
    about: 'Learn more about merge request functionality',
    select_target_project: 'Select source project | Select project',
    code: {
      typeProject: 'Private | Public',
      showMatches: 'Show more matches ({countMatches})',
      turn: 'Collapse'
    }
  },
  ru: {
    merge_request_cmd:
      'Также вы можете воспользоваться командной строкой или вашей IDE для закрытия данного запроса.',
    merge_request_cmd_train: 'Данный запрос будет добавлен на поезд слияния',
    merge_request_train_description:
      'Поезд слияния — это список запросов на слияние, каждый из которых ожидает слияния с целевой веткой.',
    merge_request_confirm_cancel: 'Вы уверены, что хотите отменить слияние?',
    merge_request_confirm_close: 'Вы уверены, что хотите закрыть слияние?',
    merge_request_confirm_merge: 'Вы уверены, что хотите совершить слияние?',
    merge_request: 'Запрос на слияние | Запросы на слияние | Нет запросов на слияние',
    create_merge_request: 'Создать запрос',
    source: 'Источник: ',
    target: 'Цель: ',
    remove_source_branch: 'Удалить исходную ветку, после того как запрос на слияние будет принят.',
    squash_commit: 'Выполнить слияние одним коммитом (squash commit).',
    wants_to_merge_branch: 'хочет слить ветку',
    branch_source: 'Ветка источника',
    lags_behind: 'отстает на',
    discussion: 'Обсуждение | Обсуждения',
    discussion_no: 'Нет дискуссий',
    discussion_closed: 'Дискуссия закрыта',
    create_discussion_new: 'Начать новую дискуссию',
    discussion_created: 'начал(а) новую дискуссию {date}',
    discussion_choose: 'дискуссию',
    answered_last: 'Последним ответил(а)',
    commit: 'коммит | коммита | коммитов',
    merge_request_assigned_to_me: 'Назначен на меня',
    pipeline: 'Конвейер | Конвейеры',
    describe_reason: 'Опишите причину блокировки',
    manual_merge_disabled: 'Ручное слияние отключено, необходимо отключить автоматическое слияние',
    mergeRequestNameTitle: 'Название',
    statusOpened: 'Открыт',
    statusClosed: 'Закрыт',
    statusMerged: 'Слит',
    statusTrained: 'Добавленные в поезд на слияние',
    statusTrainConflict: 'Конфликт при прохождении поезда',
    DISMISSED: 'Отменен',
    CONFIRMED: 'Подтвердить',
    cancelMergeCommit: 'Отменить',
    labelMergeCommitField: 'Сообщение merge-коммита',
    labelSquashCommitField: 'Сообщение squash-коммита',
    enableSquashCommit: 'Изменить сообщение для squash-коммита',
    infoSquashCommit:
      'Если сообщение для squash-коммита пустое, то будет использовано сообщение по умолчанию',
    titleMergeCommitField: 'Создание коммита',
    isBlocked: {
      allRequests: 'Все запросы',
      blockedRequests: 'Заблокированные',
      unblockedRequests: 'Не заблокированные'
    },
    viewType: 'Вид отображения',
    inlineType: 'Построчный',
    splitType: 'Разделенный',
    commitInBranch: 'Коммит будет сделан в ветку',
    markAsResolved: 'Применить',
    resolveConflicts: 'Решить конфликты',
    resolveConflictsDescription: 'Решение конфликтов слияния между ветками',
    commitCreate: 'Создание коммита',
    conflictsResolvedInBranch: 'Решены конфликты в ветке',
    branchesWithNoDiff:
      'Ветки <code>{sourceBranch}</code> и <code>{targetBranch}</code> не имеют различий.',
    mergeRequestDisabled: {
      differentMergeBaseFork:
        'Ветка-источник и целевая ветка имеют совершенно разную историю коммитов.',
      differentMergeBase:
        'Вы не сможете создать запрос на слияние, так как ветка-источник и целевая ветка имеют совершенно разную историю коммитов.'
    },
    nothingToCompare: 'Нечего сравнивать',
    revertCommitHeaderMessage: 'Отмена коммита "{commitMessage}"',
    revertCommitDescriptionMessage: 'Этот коммит отменит {commitToRevert} ("{commitMessage}")',
    sourceBranchNeedToRebase: 'Перебазировать',
    sourceBranchNeedToRebaseDescription: 'Необходимо перебазировать ветку-источник',
    sourceBranchNeedToRebaseLocalDescription:
      'Необходимо решить конфликты и перебазировать ветку-источник',
    identicalBranches: 'Ветки идентичны',
    identicalBranchesDescription:
      'Вы не сможете создать запрос на слияние, так как выбраны две идентичные ветки',
    runPipelineMergeRequests:
      'Создание конвейера результата слияния невозможно в запросе на слияние с конфликтами',
    code: {
      typeProject: 'приватный | публичный',
      showMatches: 'Показать еще совпадения ({countMatches})',
      turn: 'Свернуть'
    },
    select_target_project: 'Выберите исходный проект | Выберите проект',
    about: 'Подробнее про функционал запросов на слияние'
  }
};
